
/**
 * @file colors.js
 * @author Geoffrey Pursell
 * @desc Defines the color palette used for charts and graphs.
*/


define('colors',[],
       function () {
    console.log("MODULE: colors");

    /**
	 * @exports colors
	 * @desc Defines the color palette used for charts and graphs.
	 */

    var Colors = {

         blue1: { dark: "#003865", medium: "#003865", light: "#003865" },
         green: { dark: "#78BE21", medium: "#78BE21", light: "#78BE21" },
         blue2: { dark: "#008EAA", medium: "#008EAA", light: "#008EAA" },
         green2: { dark: "#0D5257", medium: "#0D5257", light: "#0D5257" },
        orange: { dark: "#8D3F2B", medium: "#8D3F2B", light: "#8D3F2B" },
        purple: { dark: "#5D295F", medium: "#5D295F", light: "#5D295F" },
        blue3: { dark: "#A4BCC2", medium: "#A4BCC2", light: "#A4BCC2" },
        cream: { dark: "#F5E1A4", medium: "#F5E1A4", light: "#F5E1A4" },
        blue4: { dark: "#9BCBEB", medium: "#9BCBEB", light: "#9BCBEB" },
        yellow: { dark: "#D7D701", medium: "#FFFF78", light: "#FFFF6F" },
        fluorYellow: { dark: "#D7D701", medium: "#FFFF78", light: "#FFFF6F" },
        brown: { dark: "#8a3324", medium: "#cd853f", light: "#cd853f" },
        grey2: { dark: "#97999B", medium: "#97999B", light: "#97999B" },
        magenta: { dark: "#FF0090", medium: "#FF6FFF", light: "#FF6FFF" },
        gold: { dark: "#FFC845", medium: "#FFC845", light: "#FFC845" },
        red: { dark: "#892326", medium: "#b02428", light: "#cc2027" },
        grey: { dark: "#53565A", medium: "#53565A", light: "#53565A" }
    };

    return Colors;
});

